<template>
    <div>
        <design-2021-apprentice-data-table
            v-if="lasGroups.length !== 0"
            :items="lasGroups"
            :fields="fields">
            <template v-slot:cell(actions)="data">
                <b-form-checkbox
                    :checked="!!data.item.checked"
                    @change="update(data.item, $event)"
                    switch>
                </b-form-checkbox>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header"
            v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{ $t('group.no_class_linked') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-show-las-group-component',
    props: ['lasGroupsIn'],
    data() {
        return {
            lasGroups: this.lasGroupsIn,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                },
            ],
        };
    },
    methods: {
        update(group, value) {
            if (value) {
                this.$emit('add-las-group', group);
            } else {
                this.$emit('remove-las-group', group);
            }
        },
    },
};
</script>

<style scoped></style>
